export const DataManagementRoutesConfig = {
  dataManagementPage: "/data-management",
  generateTemplate: "/data-management/generate-template",
};
